import React, { Component } from 'react'
import Router from 'next/router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ContactActionCreators } from 'app/reducers/ContactReducer'
import { companyConfig } from 'globalConfigApp'
import config from 'config'

import ContactForm from 'components/Forms/ContactFormPage'
import ContactFooter from 'components/Landing/ContactFooter'
import { getAnalyticActionTrackerLink } from 'components/Contact/linkConfig'
import Map, { Pin } from 'components/Map'
import { image } from 'services'
import { NEXIMO_ADDRESS, NEXIMO_LAT, NEXIMO_LNG } from 'services/config'

const CONTACT_PHONE = config('CONTACT_PHONE')

import IconInfo from './IconInfo'

import styles from './style'

const iconsList = [
  {
    title: 'Teléfono',
    icon: 'ios-call',
    content: `+52 ${CONTACT_PHONE}`
  },
  {
    title: 'Email',
    icon: 'md-mail',
    content: `info@${companyConfig.companyDomain}`
  },
  {
    title: 'Dirección',
    icon: 'md-pin',
    content: `${NEXIMO_ADDRESS}`
  }
]

class Contact extends Component {
  componentDidMount() {
    this.props.actions.cleanData()
  }

  contactForm = () => {
    const { loadingSentData, successSentData, failureSentData } = this.props
    if (loadingSentData) {
      return (
        <div className="wrapper-response">
          <h3>Enviando...</h3>
          <style jsx>{styles}</style>
        </div>
      )
    }

    if (!loadingSentData && !successSentData && !failureSentData) {
      return <ContactForm onSubmit={this.handleOnSubmit} />
    }

    if (!loadingSentData && successSentData && !failureSentData) {
      return (
        <div className="wrapper-response">
          <h3>
            <strong>¡Tu formulario se envió correctamente!</strong>
          </h3>
          <img
            src={image('/icons/icono-admin-mensaje-enviado.svg')}
            alt="Mensaje enviado"
          />
          <p>En breve uno de nuestros representantes se comunicará contigo.</p>
          <p>No olvides que tenemos más formas de contacto.</p>
          <br />
          <style jsx>{styles}</style>
        </div>
      )
    }
    if (failureSentData) {
      return (
        <div className="wrapper-response">
          <h3>Lo sentimos, tuvimos un error.</h3>
          <p>Por favor intenta más tarde.</p>
          <p>No olvides que tenemos más formas de contacto.</p>
          <br />
          <style jsx>{styles}</style>
        </div>
      )
    }
  }

  handleOnSubmit = values => {
    this.props.actions.sentData(values)

    this.handleRequestContact()
  }

  handleRequestContact = () =>
    this.changeAnalyticActionRoute('CONTACT_REQUESTED')

  changeAnalyticActionRoute = (analyticAction) => {
    const analyticActionTrackerLink = getAnalyticActionTrackerLink(
      analyticAction
    )

    Router.push(
      analyticActionTrackerLink.href,
      analyticActionTrackerLink.as,
      { shallow: true }
    )
  }

  render() {
    return (
      <div className="contact-page-wrapper">
        <div className="hero">
          <h2 className="title">
            <strong>Soporte {companyConfig.name}</strong>
          </h2>
          <p className="schedule">
            Lun a Vie 9 a 18 hrs
          </p>
           <p className="message-welcome">
             Comunícate con nosotros, envíanos
             tus comentarios, quejas o sugerencias
           </p>
          
        </div>
        <div className="wrapper-icons">
          {iconsList.map((il, index) => (
            <IconInfo key={index} {...il} />
          ))}
        </div>
        {this.contactForm()}
        <div className="address">
          <h4>Nos encontramos en:</h4>
          <p>
            { NEXIMO_ADDRESS }
          </p>
        </div>
        <div className="wrapper-map">
          <Map lat={NEXIMO_LAT} lng={NEXIMO_LNG}>
            <Pin lat={NEXIMO_LAT} lng={NEXIMO_LNG} />
          </Map>
        </div>
        <ContactFooter />
        <style jsx>{styles}</style>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      sentData: ContactActionCreators.sentDataContactRequest,
      cleanData: ContactActionCreators.sentDataContactClean
    },
    dispatch
  )
})

const mapStateToProps = state => {
  return {
    loadingSentData: state.contact.loading,
    successSentData: state.contact.success,
    failureSentData: state.contact.error
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact)
